import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ShowClientPage } from '@/clients/pages/show';
import { getClientQueryOptions } from '@/clients/queries';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/clients/$clientId')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  loader: ({ context: { queryClient }, params: { clientId } }) => {
    const parsedClientId = parseInt(clientId);
    return queryClient.ensureQueryData(getClientQueryOptions(parsedClientId));
  },
  component: ShowClientRoute
});

function ShowClientRoute() {
  const clientId = Route.useParams().clientId;
  const parsedClientId = parseInt(clientId);
  const { data: client } = useSuspenseQuery(getClientQueryOptions(parsedClientId));

  return (
    <ShowClientPage clientId={parsedClientId} client={client} />
  );
}
